export default "__VITE_ASSET__132cd703__"